var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.career
    ? _c(
        "div",
        { staticClass: "careers" },
        [
          _c(
            "div",
            { staticClass: "careers__content" },
            [
              _c("title-view", { attrs: { variant: "primary align-left" } }, [
                _vm._v("\n      " + _vm._s(_vm.career.name) + "\n    ")
              ]),
              _vm._l(_vm.career.text, function(section, index) {
                return _c(
                  "div",
                  { key: index },
                  [
                    _c(
                      "text-view",
                      {
                        attrs: { variant: "small-margin subtitle align-left" }
                      },
                      [_c("h3", [_vm._v(_vm._s(section.title))]), _c("br")]
                    ),
                    _c("text-view", [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(section.body) }
                      }),
                      _c("br")
                    ])
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "a",
            {
              staticClass: "careers__action",
              attrs: {
                href: _vm.career.url,
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [
              _c("button-view", { attrs: { variant: "title big" } }, [
                _vm._v("\n      " + _vm._s(_vm.career.action) + "\n    ")
              ])
            ],
            1
          ),
          _c("footer-follow-view")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-108811ca", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-108811ca","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/careers/show.vue
// module id = 578
// module chunks = 5